import { Row } from 'antd'
import React from 'react'

function ANTDRow({ ...props }) {
  return <Row {...props} />
}

export default ANTDRow
